module.exports = {
      id: "bdnews24-logo-usage",
      viewBox: "0 0 770 92",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#bdnews24-logo",
      toString: function () {
        return this.url;
      }
    }